import { render, staticRenderFns } from "./RoleCreateDetails.vue?vue&type=template&id=ac47faf2&"
import script from "./RoleCreateDetails.vue?vue&type=script&lang=js&"
export * from "./RoleCreateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports